import React from "react";

// Icons
import { GiPayMoney } from 'react-icons/gi';
import { FaUniversity } from 'react-icons/fa';
import { BsBriefcaseFill } from 'react-icons/bs';
import { GiSkills } from 'react-icons/gi';
import { MdModelTraining } from 'react-icons/md';
import { PiStudentFill } from 'react-icons/pi';
// import PageWrapper from "./PageWrapper";

const Features = () => {
  const features = [
    
    {
      title: "No/Low Tuition Fee",
      details: "Accessible and affordable global education options.",
      icon: <GiPayMoney className="text-white h-6 w-6" />
    },
    {
      title: "Top-Ranked Universities",
      details: "Study at highly reputed institutions worldwide.",
      icon: <FaUniversity className="text-white h-6 w-6" />
    },
    {
      title: "Career Opportunities",
      details: "Greater employability and international job exposure.",
      icon: <BsBriefcaseFill className="text-white h-6 w-6" />
    },
    {
      title: "Skill-Oriented Learning",
      details: "Focused on practical knowledge and industry readiness.",
      icon: <GiSkills className="text-white h-6 w-6" />
    },
    {
      title: "Hands-on Training",
      details: "Internships and real-world experience during study.",
      icon: <MdModelTraining className="text-white h-6 w-6" />
    },
    {
      title: "Scholarships & Aid",
      details: "Financial support to ensure smooth academic journeys.",
      icon: <PiStudentFill className="text-white h-6 w-6" />
    }
  ];

  return (
    
    <section className="py-20 px-4 bg-white">
      <div className="max-w-5xl mx-auto text-center mb-16">
  <h2 className="text-3xl font-extrabold text-gray-900 relative inline-block mb-4">
    <span className="bg-gradient-to-r from-primary to-indigo-600 text-transparent bg-clip-text">Why Choose Us</span>
  </h2>
  <p className="text-gray-600 text-lg max-w-2xl mx-auto">
    Every feature is designed to support you throughout your journey of studying abroad and advancing your career.
  </p>
</div>


      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {features.map((feature, idx) => (
          <FeatureCard key={idx} {...feature} />
        ))}
      </div>
    </section>
  );
};

const FeatureCard = ({ icon, title, details }) => {
  return (
    <div className="p-6 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition duration-300 hover:scale-[1.015]">
      <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-gradient-to-tr from-indigo-500 to-purple-500 mb-4 shadow-md">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed">{details}</p>
    </div>
  );
};

export default Features;
